export default __webpack_public_path__ + "static/img_6-7983da4608765c4516c9a5a28552ce6f.png";